import { render } from "./CRMAgentPermissionsComponent.vue?vue&type=template&id=eff192fa"
import script from "./CRMAgentPermissionsComponent.vue?vue&type=script&lang=js"
export * from "./CRMAgentPermissionsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__